import { DataCollection } from "@app/classes/infrastructure/datacollection";
import { DataContainerService } from "@app/classes/infrastructure/datacontainer.service";
import { RequestTypes } from "@app/classes/infrastructure/enums";
import { TransportData } from "@app/classes/infrastructure/transportdata";
import { Utils } from "@app/services/utils.service";

export class TodaysTaskDetailsFetchRequest {
  public static readonly FetchRequestType: string = "todays_work_details_fetch_request";

  // Which register to fetch the visit list from (FromEntityTypes enum value)
  from_entity_type: number = 0;

  // Hierarchy filters
  state_ids: number[] = [];
  zone_ids: number[] = [];
  district_ids: number[] = [];
  block_ids: number[] = [];
  phc_ids: number[] = [];
  sc_ids: number[] = [];
  village_ids: number[] = [];
  asha_ids: number[] = [];
  af_ids: number[] = [];
  asha_employee_record_ids: number[] = [];
  asha_post_ids: number[] = [];

  af_employee_record_ids: number[] = [];
  af_post_ids: number[] = [];

  bcm_employee_record_ids: number[] = [];
  bcm_post_ids: number[] = [];

  dcm_employee_record_ids: number[] = [];
  dcm_post_ids: number[] = [];

  public MergeIntoTransportData = (td: TransportData) => {
    let coll = DataContainerService.GetInstance().GetOrCreateCollection(
      td.MainData,
      TodaysTaskDetailsFetchRequest.FetchRequestType
    ) as DataCollection;
    coll.Entries.push(this);
  };

  public FormulateTransportData = () => {
    let td = Utils.GetInstance().CreateNewTransportData(RequestTypes.Fetch);
    this.MergeIntoTransportData(td);

    return td;
  };
}